// @flow
import { createSelector } from 'reselect'
import type { State as RootState } from '../types'
import type { State } from './types'

export const selectPageTree = (state: RootState): State => state.page

export const selectLoaded = createSelector(selectPageTree, tree => tree.loaded)
export const selectPage = createSelector(selectPageTree, tree => tree.data)
